const FIELDS = {
  txnId: 'txn_id',
  amount: 'amount',
  org: 'org',
  initiatedTs: 'initiated_ts',
  mode: 'mode',
  title: 'title',
};

const TEXT = {
  REFUND_SET_SUCCESS: 'Refund processed successfully',
};

const ERRORS = {
  CART_ID_MISSING: 'Cart Id is missing',
  USER_ID_MISSING: 'User Id is missing',
};

export { FIELDS, TEXT, ERRORS };
